// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ps-5";
export var filledCircle = "_ps-4";
export var historyEntry = "_ps-3";
export var messageSideLeft = "_ps-1";
export var messageSideRight = "_ps-2";
export var orderTrackingCarouselWrapper = "_ps-6";
export var orderTrackingInfoContainer = "_ps-0";